import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxKjuaModule } from 'ngx-kjua';
import { SignUpService } from '../shared/services/evergent/signup/signup.service';
import { SharedComponentsModule } from '../shared/shared-components/shared.components.module';
import { LinkTvComponent } from './link-tv.component';
import { LinkTvService } from './link-tv.service';
import { LinkTvRoutingModule } from './link-tv-routing.module';

@NgModule({
  declarations: [LinkTvComponent],
  imports: [
    CommonModule,
    SharedComponentsModule,
    NgxKjuaModule,
    TranslateModule,
    LinkTvRoutingModule,
  ],
  providers: [SignUpService, LinkTvService],
  exports: [LinkTvComponent],
})
export class LinkTvModule {}
